// extracted by mini-css-extract-plugin
export var blue = "_14-f";
export var brand = "_14-b";
export var darkGrey = "_14-e";
export var disabled = "_14-4";
export var disabledSubtle = "_14-5";
export var error = "_14-6";
export var green = "_14-g";
export var grey = "_14-d";
export var icon = "_14-0";
export var inherit = "_14-a";
export var lightGrey = "_14-c";
export var orange = "_14-i";
export var pink = "_14-k";
export var primary = "_14-1";
export var purple = "_14-l";
export var red = "_14-j";
export var secondary = "_14-2";
export var success = "_14-9";
export var tertiary = "_14-3";
export var warning = "_14-7";
export var warningSecondary = "_14-8";
export var white = "_14-m";
export var yellow = "_14-h";